import { AppHelper } from '../appHelper/appHelper';
import { Injectable } from "@angular/core";

@Injectable()
export class CacheUriRegistrationService {
    private includedUris = new Map<string, number>(); // number is the TTL in seconds
    private excludedUris = new Map<string, boolean>();

    checkIncluded(serviceUri: string): number {
        return this.includedUris.get(serviceUri);
    }

    checkExcluded(serviceUri: string): boolean {
        return this.excludedUris.get(serviceUri);
    }

    addInclusion(serviceUri: string, ttl: number = AppHelper.defaultCacheTimeoutSeconds) {
        if (!this.checkIncluded(serviceUri)) {
            this.includedUris.set(serviceUri, ttl);
        }
    }
    
    addExclusion(serviceUri: string, ttl: number = AppHelper.defaultCacheTimeoutSeconds) {
        if (!this.checkExcluded(serviceUri)) {
            this.excludedUris.set(serviceUri, true);
        }
    }
    
}